<template>
    <v-select 
       :value="selected_initiator" 
       v-bind:items="initiators"
       v-bind:rules="initiatorRules"
       item-value="code" 
       item-text="description" 
       :label="label"
       dense :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_initiator: String,
        label: {
            type: String,
            default: 'Caused by'
        },    
        field: {
            default: 'homb_initiatief',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
    },  
    data() {
        return {
            initiatorRules: [v => !!v || "A value is required"],
            initiators: 
                [
                    // {code: 'guest', description: 'Guest'},
                    {code: 'owner', description: 'Owner'},
                    {code: 'caretaker', description: 'Caretaker'},
                    {code: 'rentalexpert', description: 'Rental expert'},
                    {code: 'other', description: 'Other'}
                ],
        }
    },
    methods: {
        updateData(v){
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
        }
    }
}

</script>